import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Form } from '../../shared/form';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { Ship } from '../../_models/ship';
import { ShipType } from '../../_models/ship-type';
import { ShipService } from '../../_services/ship.service';

@Component({
  selector: 'app-ship-form',
  templateUrl: './ship-form.component.html',
  styleUrls: ['./ship-form.component.sass'],
})
export class ShipFormComponent extends Form implements OnInit {
  // Component attributes
  form: FormGroup;
  ship: Ship;
  shipTypes: ShipType[];
  periods: string[] = ['2017'];
  currentPeriod = '2017';

  constructor(
    private fb: FormBuilder,
    private shipService: ShipService,
    protected route: ActivatedRoute,
    protected router: Router,
    private location: Location,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);
    this.form = fb.group({
      code: null,
      cfr: null,
      ircs: null,
      high_in_rgfp: null,
      state_in_rgfp: null,
      total_length_m: null,
      power_kw: null,
      base_port: null,
      census_by_modality: null,
      imo: null,
      plate: null,
      gt_arc: null,
      hull_material: null,
      name: [''],
      type: '',
      dea_user: '',
      dea_password: '',
    });
  }

  ngOnInit() {
    this.getTypes();

    if (this.location.path() === '/ships/add') {
      this.ship = new Ship();
      this.setFormMode('create');
    } else {
      this.getShip();
      this.setFormMode('update');
    }
  }

  getTypes() {
    this.shipService.getTypes().subscribe(
      (data) => {
        this.shipTypes = ShipType.generateCollectionFromApi(data['actions']['POST']['type']['choices']);
      },
      (error) => this.handleError(error)
    );
  }

  getShip() {
    this.route.params.forEach((params: Params) => {
      const id = +params['id'];
      this.shipService.getShip(id).subscribe(
        (ship) => (this.ship = ship),
        (error) => this.handleError(error)
      );
    });
  }

  handleError(error) {
    const errors = this.httpErrorHandler.handleHttpError(error);
    this.parseApiErrors(errors, this.form);
  }

  onSubmit() {
    if (this.createMode) {
      this.createShip();
    } else {
      this.updateShip();
    }
  }

  createShip() {
    this.shipService.create(this.ship).subscribe(
      (ship) => this.onCreate(ship),
      (error) => this.handleError(error)
    );
  }

  updateShip() {
    this.shipService.update(this.ship).subscribe(
      (ship) => this.onUpdate(ship),
      (error) => this.handleError(error)
    );
  }

  onCreate(ship) {
    this.goBack();
  }

  onUpdate(ship) {
    this.goBack();
  }

  goBack(): void {
    this.location.back();
  }

  setCurrentPeriod(period) {
    this.currentPeriod = period;
  }
}



// WEBPACK FOOTER //
// ./src/app/ships/ship-form/ship-form.component.ts